module.exports = __webpack_public_path__ + "img/bs2.eb118b0a.png";